import React, { useState, useEffect } from "react";
import moment from "moment";
import {
  setactionType,
  setInterVal,
  setIsDashboard,
  setNewCaseInFoID,
} from "../../../../../redux/slice/DashBoardSlice";
import { useDispatch } from "react-redux";
import AccordionComponent from "../../../../../common/Accordion";
import MonthIntervalDropdown from "../../../../../common/MonthIntervalDropdown";
import { Card, Col, Row } from "react-bootstrap";
import CommonProgressBar from "../CommonProgressBar";
import { getRORInvoiceOverview } from "../../../../../services/RORDashboardAPI";
import { WEB_ROLE } from "../../../../../common/Constant";
import { getHistorianInvoiceOverview } from "../../../../../services/HistorianDashboardAPI";
import { getEditorInvoiceOverview } from "../../../../../services/EditorDashboardAPI";
import { getTranscriberInvoiceOverview } from "../../../../../services/TranscriberDashboardAPI";

interface ResultProps {
  openDropdown: string | null;
  setOpenDropdown: React.Dispatch<React.SetStateAction<string | null>>;
  userRole?: any;
}

const RORInvoiceOverview: React.FC<ResultProps> = ({
  openDropdown,
  setOpenDropdown,
  userRole,
}) => {
  const [interval, setInterval] = useState<string>("1");
  const [intervalLabel, setIntervalLabel] = useState<string>("This Month");
  const [caseActions, setCaseActions] = useState<any[]>([]);

  const fetchInvoiceData = async () => {
    try {
      let response;

      switch (userRole) {
        case WEB_ROLE.Record_Reviewer:
          response = await getRORInvoiceOverview(interval);
          break;

        case WEB_ROLE.Historian:
          response = await getHistorianInvoiceOverview(interval);
          break;

        case WEB_ROLE.Editor:
          response = await getEditorInvoiceOverview(interval);
          break;

        case WEB_ROLE.Transcriber:
          response = await getTranscriberInvoiceOverview(interval);
          break;

        default:
          response = [];
      }

      setCaseActions(response);
    } catch (error) {
      console.error("Failed to fetch invoice overview:", error);
    }
  };

  const getValueByType = (type: string) =>
    caseActions.find((a) => a.actionType === type)?.actionTypeCount || 0;

  const [CaseActionKey, setCaseActionKey] = useState<string | null>("0");

  const handleBodyAccordionSelect = (key: string | null) => {
    // Prevent collapsing if the same key is clicked
    if (CaseActionKey === key) {
      return; // do nothing
    }
    setCaseActionKey(key || "0");
  };

  const CaseActionAccordion = (
    items: { title: JSX.Element; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={CaseActionKey}
      onSelect={handleBodyAccordionSelect}
    />
  );

  const handleIntervalChange = (
    intervalValue: string | number,
    label: string,
  ) => {
    setInterval(String(intervalValue));
    setIntervalLabel(label);
  };
  const getCaseInfoIdsByType = (type: string): number[] => {
    const ids = caseActions.find((a) => a.actionType === type)?.caseInfoIds;
    return ids ? ids.split(",").map((id: any) => Number(id.trim())) : [];
  };

  useEffect(() => {
    fetchInvoiceData();
  }, [interval]);

  return (
    <>
      {CaseActionAccordion([
        {
          title: (
            <div className="d-flex justify-content-between align-items-center w-100 p-0">
              <span className="">Invoice Overview</span>
              <MonthIntervalDropdown
                title={intervalLabel}
                onSelect={handleIntervalChange}
                stopPropagation={true}
                show={openDropdown === "RORInvoiceMonth"}
                onToggle={(isOpen) =>
                  setOpenDropdown(isOpen ? "RORInvoiceMonth" : null)
                }
              />
            </div>
          ),
          content: (
            <>
              <div>
                <Row className="g-3 ">
                  <Col md={4}>
                    <div className="invoice-card case-action-box">
                      <div className="invoice-content">
                        <div className="icon-box">
                          <span className="material-symbols-outlined">
                            receipt_long
                          </span>
                        </div>

                        <div className="text-content">
                          <h4>Invoice Generated</h4>
                          <h2
                            className="fw-bold mb-0"
                            style={{ color: "#0092D5" }}
                          >
                            {getValueByType("Invoice Generated")}
                          </h2>
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="invoice-card case-action-box">
                      <div className="invoice-content">
                        <div className="icon-box icon-box-2">
                          <span className="material-symbols-outlined">
                            timer
                          </span>
                        </div>

                        <div className="text-content">
                          <h4>Pending Invoice</h4>
                          <h2
                            className="fw-bold mb-0"
                            style={{ color: "#E45713" }}
                          >
                            {getValueByType("Pending Invoice")}
                          </h2>
                        </div>
                      </div>
                    </div>
                  </Col>

                  {(userRole == WEB_ROLE.Record_Reviewer ||
                    userRole == WEB_ROLE.Historian) && (
                    <Col md={4}>
                      <div className="invoice-card case-action-box">
                        <div className="invoice-content">
                          <div className="icon-box icon-box-3">
                            <span className="material-symbols-outlined">
                              auto_stories
                            </span>
                          </div>

                          <div className="text-content">
                            <h4>
                              {userRole == WEB_ROLE.Record_Reviewer
                                ? `Total Pages`
                                : `Total History Pages`}
                            </h4>
                            <h2
                              className="fw-bold mb-0"
                              style={{ color: "#6C54E6" }}
                            >
                              {getValueByType("Total Pages")}
                            </h2>
                          </div>
                        </div>
                      </div>
                    </Col>
                  )}
                  {(userRole == WEB_ROLE.Editor ||
                    userRole == WEB_ROLE.Transcriber) && (
                    <Col md={4}>
                      <div className="invoice-card case-action-box">
                        <div className="invoice-content d-flex align-items-center">
                          {/* Icon */}
                          <div className="icon-box icon-box-3 me-3">
                            <span className="material-symbols-outlined">
                              auto_stories
                            </span>
                          </div>

                          {/* Text Content */}
                          <div className="flex-grow-1">
                            <h6 className="mb-2 fw-semibold">Total</h6>

                            <div className="d-flex align-items-center">
                              {/* Pages Section */}
                              <div className="pe-3">
                                <div className="small text-muted">Pages</div>
                                <h5
                                  className="fw-bold mb-0"
                                  style={{ color: "#6C54E6" }}
                                >
                                  {getValueByType("Total Pages")}
                                </h5>
                              </div>

                              {/* Divider */}
                              <div
                                style={{
                                  width: "1px",
                                  height: "35px",
                                  backgroundColor: "#ddd",
                                }}
                              />

                              {/* Lines Section */}
                              <div className="ps-3">
                                <div className="small text-muted">Lines</div>
                                <h5
                                  className="fw-bold mb-0"
                                  style={{ color: "#6C54E6" }}
                                >
                                  {getValueByType("Total Lines")}
                                </h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  )}
                </Row>
              </div>
            </>
          ),
        },
      ])}
    </>
  );
};

export default RORInvoiceOverview;
